import React from 'react';
import {
  Stack,
  Alert,
  AlertTitle,
  Skeleton,
} from '@mui/material';
import { TeamMember, Traveler } from '@marageti/z4-sdk/lib/people';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import TravelerCard from '../../traveler-card';
import TripRequestDetails from '../../trip-request-details';
import TravelerProfileNotesSection from '../../traveler-profile-notes';
import { getChipsFromTripRequest } from '../../../utils/chips';

type TripRequestDetailsSidebarViewProps = {
  error: ApiError | null;
  loggedInTeamMember: TeamMember | null;
  travelers: Traveler[] | undefined;
  travelerId: string | undefined;
  tripRequest: TripRequest | undefined;
  onTravelerEdit: () => void;
  onEditSuccess: () => void;
};

const TripRequestDetailsSidebarView = ({
  error,
  loggedInTeamMember,
  travelers,
  travelerId,
  tripRequest,
  onTravelerEdit,
  onEditSuccess,
}: TripRequestDetailsSidebarViewProps) => (
  <Stack
    spacing={2}
  >
    {error && (
      <Alert severity="error">
        <AlertTitle>
          There was an error loading information
        </AlertTitle>
        {error.message}
        {error.code && ` Code: ${error.code} `}
        {error.id && ` ID: ${error.id}`}
      </Alert>
    )}
    <TravelerCard
      travelers={travelers || []}
      tripRequest={tripRequest}
      onEditProfile={onTravelerEdit}
      onEditEmail={onTravelerEdit}
    />
    {tripRequest && (
      <TripRequestDetails
        chips={getChipsFromTripRequest(tripRequest)}
        tripRequest={tripRequest}
        loggedInTeamMember={loggedInTeamMember}
        title="Trip Details"
        onEditSuccess={onEditSuccess}
      />
    )}
    {travelerId ? (
      <TravelerProfileNotesSection travelerId={travelerId} />
    ) : (
      <Skeleton variant="rounded" height={160} />
    )}
  </Stack>
);

export default TripRequestDetailsSidebarView;
